import * as Yup from 'yup';

import { Button, Col, Container, Modal, Row } from 'react-bootstrap';
import { Field, Formik } from 'formik';
import React, { useRef, useState } from 'react';

import CheckDisc from '../../assets/svg/disc/check-disc.svg';
import CloseButton from '../Styled/CloseButton';
import ErrorLabel from '../ErrorLabel';
import { Form } from 'react-bootstrap';
import LoopSpinner from '../LoopSpinner';
import ReactMarkdown from 'react-markdown';
import { contentfulPropTypes } from '../../propTypes';
import cx from 'classnames';
import { dark } from '../../theme/colors';
import { registerContactInHubspot } from '../../api/Hubspot';
import styled from 'styled-components';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledButton = styled(Button)`
  text-decoration: none;
  color: ${dark};
`;

const StyledHeader = styled(Modal.Header)`
  position: absolute;
  right: 0;
  z-index: 1000;
`;

const schema = Yup.object().shape({
  emailAddress: Yup.string()
    .email('Please enter a valid email address')
    .required('Please enter your email address'),
});

const NetZeroEmailModal = ({ contentful, loading, fetched, show, onClose }) => {
  const inputRef = useRef(null);
  const [showSuccess, setShowSuccess] = useState(false);

  const onRegisterEmail = async ({ emailAddress }) => {
    registerContactInHubspot(contentful.link, emailAddress).then(() =>
      setShowSuccess(true),
    );
  };

  return (
    !loading &&
    fetched && (
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onClose}>
        <StyledHeader>
          <CloseButton onClick={onClose} variant={'bordered'} />
        </StyledHeader>
        <Modal.Body className="pt-0">
          <Container fluid>
            <Row>
              <Col className="text-center">
                {showSuccess && (
                  <img
                    src={CheckDisc}
                    alt="Green check mark"
                    className="mt-5 mb-4"
                  />
                )}
                <h1 className="pt-4 pb-3">{contentful?.title}</h1>
                {!showSuccess ? (
                  <Formik
                    onSubmit={onRegisterEmail}
                    initialValues={{
                      emailAddress: '',
                    }}
                    validationSchema={schema}>
                    {({ handleSubmit, isSubmitting, isValid }) => (
                      <Form onSubmit={handleSubmit}>
                        <ReactMarkdown>{contentful?.body}</ReactMarkdown>
                        <Field name="emailAddress">
                          {({ field, meta }) => (
                            <div className="mb-4">
                              <Form.Control
                                type="email"
                                ref={inputRef}
                                name={field.name}
                                value={field.value}
                                onChange={field.onChange}
                                onBlur={field.onBlur}
                                isValid={!meta.error && meta.touched}
                                className={`border-color-light ${cx({
                                  error: !!meta.error && !!meta.touched,
                                })}`}
                                placeholder="Email address"
                              />
                              {meta.error && meta.touched && (
                                <ErrorLabel label={meta.error} />
                              )}
                            </div>
                          )}
                        </Field>
                        {!isSubmitting ? (
                          <>
                            <Button
                              variant="primary"
                              type="submit"
                              className="px-5 w-100"
                              disabled={isSubmitting || !isValid}>
                              {contentful.primaryButtonText}
                            </Button>
                            <StyledButton
                              variant="link"
                              onClick={onClose}
                              className="pb-3 w-100">
                              {contentful.secondaryButtonText}
                            </StyledButton>
                          </>
                        ) : (
                          <LoopSpinner className="p-3" />
                        )}
                      </Form>
                    )}
                  </Formik>
                ) : (
                  <>
                    <ReactMarkdown className="py-3">
                      {contentful?.bodyEnd}
                    </ReactMarkdown>
                    <Button
                      variant="primary"
                      onClick={onClose}
                      className="my-3 px-5 w-100">
                      {contentful.utilityText}
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    )
  );
};

NetZeroEmailModal.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(
  NetZeroEmailModal,
  'web_app_netzero_email_modal',
);
